// @flow

type TextType = {
  title: string,
  subTitle?: string,
};

export type Feedback = {
  type: 'PIN_SHOW_FEEDBACK' | 'PIN_HIDE_FEEDBACK' | 'PIN_SHOW_UNDO_AND_FEEDBACK',
  payload: {
    id: string,
    value: boolean,
    text?: TextType,
    undoAction?: () => void,
    undoText?: string,
  },
};

export function showPinFeedbackUndo(
  id: string,
  text: TextType,
  undoAction: () => void,
  undoText?: string,
) {
  return {
    type: 'PIN_SHOW_UNDO_AND_FEEDBACK',
    payload: {
      id,
      value: true,
      text,
      undoAction,
      undoText,
    },
  };
}

export function hidePinFeedback(id: string) {
  return {
    type: 'PIN_SHOW_FEEDBACK',
    payload: {
      id,
      value: false,
    },
  };
}

export default function showPinFeedback(id: string, text: TextType): Feedback {
  return {
    type: 'PIN_SHOW_FEEDBACK',
    payload: {
      id,
      value: true,
      text,
    },
  };
}

export function showPinFeedbackOverlay(id: string) {
  return {
    type: 'PIN_SHOW_FEEDBACK_OVERLAY',
    payload: {
      id,
      value: true,
    },
  };
}

export function hidePinFeedbackOverlay(id: string) {
  return {
    type: 'PIN_SHOW_FEEDBACK_OVERLAY',
    payload: {
      id,
      value: false,
    },
  };
}
